module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-38.ffa94502.png";